import { render } from "./ConfigSelect.vue?vue&type=template&id=b5a1a9b2&ts=true"
import script from "./ConfigSelect.vue?vue&type=script&lang=ts"
export * from "./ConfigSelect.vue?vue&type=script&lang=ts"

import exportComponent from "/home/appstore/appstore/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__